import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import SelectPayItemLine from "../components/SelectPayItemLine.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import DateOptions from "../../../components/timeList/dateOptions.vue";
import PayOptions from "../../../components/serverList/payOptions.vue";
import { getPayMap, getPayRmbMap, getGameServerMap } from "@/utils/dictionary";
export default {
  components: {
    SelectPayItemLine: SelectPayItemLine,
    serverList: serverList,
    DateOptions: DateOptions,
    PayOptions: PayOptions
  },
  name: "OverView",
  data: function data() {
    return {
      selType: 1,
      serverList: [],
      sendTimeArrData: [this.$moment().subtract(6, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      activeName: "first",
      serverID: [],
      goodId: [],
      searchInfo: {
        server_id: [],
        good_id: []
      },
      payArray: []
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPayMap();
            case 2:
              _this.payInfo = _context.sent;
              for (index in _this.payInfo) {
                _this.payArray.push({
                  pay_id: index,
                  pay_name: _this.payInfo[index]
                });
              }
              _context.next = 6;
              return getPayRmbMap();
            case 6:
              _this.payRmbMap = _context.sent;
              _context.next = 9;
              return getGameServerMap();
            case 9:
              _this.serverInfo = _context.sent;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    ChangeTimebtn: function ChangeTimebtn() {
      var _this2 = this;
      this.serverID = this.searchInfo.server_id;
      this.goodId = this.searchInfo.good_id;
      setTimeout(function () {
        _this2.$refs.SelectPayItemLine.initTime();
      });
    },
    initPayArray: function initPayArray(data) {
      //接收子组件的初始话充值项选择
      console.log(data);
      this.searchInfo.good_id = data;
    }
  }
};